import { Box, useMediaQuery } from '@mui/material'
import React, { useContext, useEffect, useState } from 'react';
import { useParams } from 'react-router-dom'
import { IHeadCell } from '../../../../shared/interfaces/table-display.model';
import { TableDisplay } from '../../../presentation-components/miscellaneous-components/table-display';
import gaiaTheme from '../../../../root-components/theme';
import { LoadingPage } from '../../loading-page';
import { PageOuterContainer } from '../../../../root-components/layouts/page-outer-container';
import { PageHeading } from '../../../presentation-components/display-elements-components/page-heading';
import { IconName } from '../../../../shared/interfaces/icon-picker.model';
import moment from 'moment';
import { UserNotificationsContext } from '../../../../context/user-notifications/user-notifications';
import { IEnergySupplierTariffDetails, IPostEnergySupplierTariffDetails } from '../../../../shared/services/energy-supplier-tariff-details/energy-supplier-tariff-details.model';
import EnergySupplierTariffDetailsService from '../../../../shared/services/energy-supplier-tariff-details/energy-supplier-tariff-details.service';
import EnergySupplierTariffService from '../../../../shared/services/energy-supplier-tariff/energy-supplier-tariff.service';
import { IEnergySupplierTariff } from '../../../../shared/services/energy-supplier-tariff/energy-supplier-tariff.model';
import { TableActionButtons } from '../../../presentation-components/miscellaneous-components/table-action-buttons';
import { EnergySupplierTariffDetailsDialog } from '../../../dialogs/super-admin/energy-supplier-tariff-details-dialog';

export const SuperAdminEnergySupplierDetailsPage = () => {
  const { id, tariffId } = useParams()
  //Services
  const energySupplierTarrifService = new EnergySupplierTariffService()
  const energySupplierTarrifDetailsService = new EnergySupplierTariffDetailsService()
  //Context
  const userNotificationsContext = useContext(UserNotificationsContext)
  //State
  const [energySupplierTariff, setEnergySupplierTariff] = useState<IEnergySupplierTariff>()
  const [energySupplerTariffDetails, setEnergySupplierTariffDetails] = useState<IEnergySupplierTariffDetails[]>()
  const [openDialog, setOpenDialog] = useState<boolean>(false)
  const [selectedEnergySupplierTariffDetailsId, setSelectedEnergySupplierTariffDetailsId] = useState<string>()
  //Table State
  const [selected, setSelected] = useState<string[]>([]);
  const [inputPage, setInputPage] = useState(0);
  const [totalRecords, setTotalRecords] = useState(0)
  const [perPage, setPerPage] = useState(10)
  const [change, setChange] = useState<number>(0)
  const [orderBy, setOrderBy] = useState<string>()
  const [order, setOrder] = useState<'asc' | 'desc'>()
  const [errorMessage, setErrorMessage] = useState<string>()
  const [errorCode, setErrorCode] = useState<number>()
  //Loading State
  const [hasPageMounted, setHasPageMounted] = useState<boolean>(false)
  const [isLoading, setIsLoading] = useState<boolean>(true)
  const [isDialogSubmitting, setIsDialogSubmitting] = useState<boolean>(false)
  //Layout
  const isMobileMode = useMediaQuery(gaiaTheme.breakpoints.down('md'));

  //Use Effects
  useEffect(() => {
    if (tariffId) {
      getEnergySupplierTariffDetails()
      energySupplierTarrifService.getOne(tariffId)
        .then(response => {
          setEnergySupplierTariff(response)
        })
        .catch(err => {
          console.log(err)
        })
    }
  }, [inputPage, perPage, change, tariffId])

  const getEnergySupplierTariffDetails = () => {
    energySupplierTarrifDetailsService.getAllWithPagination(inputPage, perPage, orderBy, order, tariffId)
      .then(response => {
        setIsLoading(false)
        setTotalRecords(response.count);
        setEnergySupplierTariffDetails(response.rows)
      })
      .catch(err => {
        console.log(err)
      })
  }

  useEffect(() => {
    if (hasPageMounted) {
      if (inputPage === 0) {
        setChange(change + 1)
      } else {
        setInputPage(0)
      }
    }
    setHasPageMounted(true)
  }, [order, orderBy])

  //Table Contents
  const headCells: IHeadCell[] = [
    { id: 'action', numeric: false, label: 'Action', sortable: false, includeInMobile: false },
    { id: 'startDate', numeric: false, label: 'Start Date', sortable: true },
    { id: 'endDate', numeric: false, label: 'End Date', sortable: true },
    { id: 'multiplier', numeric: false, label: 'Supplier Emission Rate (kgCO2/kWh)', sortable: true },
  ];

  const rows = !energySupplerTariffDetails ? [] : energySupplerTariffDetails.map(tariffDetail => {
    return {
      id: tariffDetail.id,
      calendarYear: tariffDetail.calendarYear,
      startDate: moment(tariffDetail.startDate).format('DD/MM/YYYY'),
      endDate: moment(tariffDetail.endDate).format('DD/MM/YYYY'),
      multiplier: tariffDetail.multiplier,
      action: (
        <TableActionButtons
          id={tariffDetail.id}
          includeEdit={true}
          onEdit={() => editClickHandler(tariffDetail.id)}
        />
      )
    }
  });

  // Table Event Handlers
  const handleOrderChange = (orderBy: string, order: 'asc' | 'desc',) => {
    setOrderBy(orderBy)
    setOrder(order)
  };

  const editClickHandler = (energySupplierTariffDetailsId: string) => {
    setSelectedEnergySupplierTariffDetailsId(energySupplierTariffDetailsId)
    setOpenDialog(true)
  }

  const addClickHandler = () => {
    setSelectedEnergySupplierTariffDetailsId(undefined)
    setErrorMessage(undefined)
    setErrorCode(undefined)
    setOpenDialog(true)
  }

  const handleDialogClose = () => {
    setOpenDialog(false)
    setSelectedEnergySupplierTariffDetailsId(undefined)
    setErrorMessage(undefined)
    setErrorCode(undefined)
  }

  const submitHandler = (values: IPostEnergySupplierTariffDetails, resetForm: () => void, isEdit: boolean, energySupplierTariffDetailsId?: string) => {
    if (isEdit && energySupplierTariffDetailsId) {
      energySupplierTarrifDetailsService.edit(energySupplierTariffDetailsId, values)
        .then(response => {
          getEnergySupplierTariffDetails()
          setOpenDialog(false)
          setIsDialogSubmitting(false)
          userNotificationsContext.openSnackbar({ open: true, message: 'Updated successfully' });
        })
        .catch(err => {
          console.log(err)
          setErrorMessage(err.response.data.message)
          setErrorCode(err.response.data.code)
          setIsDialogSubmitting(false)
          userNotificationsContext.openSnackbar({ open: true, message: 'There was an error, please try again', backgroundColor: 'text.primary' });
        })
    } else {
      setIsDialogSubmitting(true)
      energySupplierTarrifDetailsService.create(values)
        .then(response => {
          setOpenDialog(false)
          getEnergySupplierTariffDetails()
          setIsDialogSubmitting(false)
          userNotificationsContext.openSnackbar({ open: true, message: 'Saved successfully' });
        })
        .catch(err => {
          console.log(err)
          setErrorMessage(err.response.data.message)
          setErrorCode(err.response.data.code)
          setIsDialogSubmitting(false)
          userNotificationsContext.openSnackbar({ open: true, message: 'There was an error, please try again', backgroundColor: 'text.primary' });
        })
    }
  }

  return (
    <PageOuterContainer>
      {energySupplierTariff && <PageHeading
        title={`${energySupplierTariff.energySupplier.name}, ${energySupplierTariff.name}`}
        includeBackButton={true}
        backButtonLink={`/super-admin/energy-suppliers/${id}`}
        backButtonText={`Back to energy supplier tariff`}
        includeActionButton={true}
        actionButtonIcon={IconName.Add}
        actionButtonHandler={addClickHandler}
        actionButtonText={`Add Supplier Emission Rate`}
      />}
      <Box sx={{ width: '100%' }}>
        <LoadingPage pageReady={!isLoading}>
          {energySupplerTariffDetails &&
            <TableDisplay
              onOrderChange={handleOrderChange}
              isMobileMode={isMobileMode}
              headCells={headCells}
              rows={rows}
              selectByIcon={true}
              selected={selected}
              setSelected={setSelected}
              inputPage={inputPage}
              setInputPage={setInputPage}
              totalRecords={totalRecords}
              perPage={perPage}
              setPerPage={setPerPage} />}
        </LoadingPage>
        {openDialog && tariffId && selectedEnergySupplierTariffDetailsId &&
          <EnergySupplierTariffDetailsDialog
            open={openDialog}
            isEdit={true}
            energySupplierTariffDetailsId={selectedEnergySupplierTariffDetailsId}
            energySupplierTariffId={tariffId}
            closeHandler={handleDialogClose}
            isSubmitting={isDialogSubmitting}
            onSubmit={submitHandler}
            errorMessage={errorMessage}
            errorCode={errorCode}
          />
        }
        {openDialog && tariffId && !selectedEnergySupplierTariffDetailsId &&
          <EnergySupplierTariffDetailsDialog
            open={openDialog}
            isEdit={false}
            energySupplierTariffId={tariffId}
            closeHandler={handleDialogClose}
            isSubmitting={isDialogSubmitting}
            onSubmit={submitHandler}
            errorMessage={errorMessage}
            errorCode={errorCode}
          />
        }
      </Box>
    </PageOuterContainer>
  )
}